module.exports = __webpack_public_path__ + "media/site_templates/www.fixholeinwall.com.au/images/our_services_2-b0a92e9a1fbb14316341a31dba82b283.jpg";